var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.238,
    height: 20.238,
    viewBox: "0 0 20.238 20.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2bc6ce;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.119,3.84A8.279,8.279,0,1,1,3.84,12.119,8.279,8.279,0,0,1,12.119,3.84m0-1.84a10.073,10.073,0,1,0,7.169,2.95A10.119,10.119,0,0,0,12.119,2Z",
    transform: "translate(-2 -2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.06 5.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.709,18.939l3.882-3.914a.62.62,0,0,0,0-.913L14.709,10.2a.685.685,0,0,0-.881-.065.62.62,0,0,0-.065.979l2.805,2.805H9.652a.652.652,0,1,0,0,1.3h6.916l-2.805,2.805a.62.62,0,0,0,.065.979A.685.685,0,0,0,14.709,18.939Z",
    transform: "translate(-9 -10.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWifi);
export default __webpack_public_path__ + "static/media/arrow-wifi.5948d38fb887600345c9dd45092e4e96.svg";
export { ForwardRef as ReactComponent };